const LyricsSvg: React.FC<{ color?: string }> = ({ color }) => {
  return (
    <svg
      width="33"
      height="34"
      viewBox="0 0 33 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.0157 26.6574C25.2964 26.3804 25.4568 26.004 25.462 25.6096V12.6796H26.462V25.5896C26.462 26.2527 26.1987 26.8886 25.7298 27.3574C25.261 27.8263 24.6251 28.0896 23.962 28.0896H8.96205C8.30246 28.0897 7.66958 27.829 7.20131 27.3645C6.73304 26.9 6.46732 26.2692 6.46205 25.6096V8.60965C6.45941 8.27966 6.52212 7.95242 6.64658 7.64679C6.77103 7.34117 6.95476 7.0632 7.18717 6.82894C7.41958 6.59467 7.69607 6.40873 8.0007 6.28184C8.30532 6.15496 8.63205 6.08963 8.96205 6.08965H21.082L26.462 11.5096H23.202C22.6309 11.507 22.0841 11.2783 21.6812 10.8735C21.2782 10.4687 21.052 9.92078 21.052 9.34965V7.08965H8.96205C8.76337 7.08963 8.56667 7.12908 8.38336 7.20571C8.20006 7.28234 8.03381 7.39462 7.89425 7.53603C7.7547 7.67745 7.64463 7.84517 7.57044 8.02948C7.49624 8.21378 7.4594 8.41099 7.46205 8.60965V25.6096C7.46731 26.004 7.62766 26.3804 7.9084 26.6574C8.18913 26.9344 8.56766 27.0897 8.96205 27.0896H23.962C24.3564 27.0897 24.735 26.9344 25.0157 26.6574ZM10.502 13.1296H17.442V14.1296H10.502V13.1296ZM22.442 16.1296H10.502V17.1296H22.442V16.1296ZM10.502 19.1296H22.442V20.1296H10.502V19.1296Z"
        fill={color || "white"}
      />
      {/* <rect
        x="0.337006"
        y="0.964645"
        width="32.25"
        height="32.25"
        stroke="#8B8B8B"
        stroke-width="0.25"
      /> */}
    </svg>
  );
};

export default LyricsSvg;
